import { createRoute } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { SettingsPage } from '../../Views'

export const settingsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/settings',
  component: SettingsPage,
})
